export default __webpack_public_path__ + "static/media/abandon@2x.e144ab26.png";